import { render, staticRenderFns } from "./cate.vue?vue&type=template&id=0c25a7aa&scoped=true&"
import script from "./cate.vue?vue&type=script&lang=js&"
export * from "./cate.vue?vue&type=script&lang=js&"
import style0 from "./cate.vue?vue&type=style&index=0&id=0c25a7aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c25a7aa",
  null
  
)

export default component.exports